import SocialNetworks from "./social-networks";

export default SocialNetworks;
